export default __webpack_public_path__ + "static/media/tech-stack-desktop.f1d98016.png";